var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    { staticClass: "mx-auto", attrs: { "max-width": "600" } },
    [
      _c(
        "v-toolbar",
        { attrs: { color: "rgb(82, 152, 68)", dark: "" } },
        [
          _c("v-toolbar-title", [_vm._v("Available Tenants")]),
          _vm._v(" "),
          _c("v-spacer"),
        ],
        1
      ),
      _vm._v(" "),
      _vm.loading
        ? _c(
            "div",
            [
              _c("v-btn", {
                staticStyle: { width: "50%" },
                attrs: { round: "", disabled: "", "py-6": "" },
              }),
              _vm._v(" "),
              _c("v-btn", { attrs: { block: "", round: "", disabled: "" } }),
              _vm._v(" "),
              _c("v-btn", { attrs: { block: "", round: "", disabled: "" } }),
              _vm._v(" "),
              _c("v-btn", { attrs: { block: "", round: "", disabled: "" } }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.loading
        ? _c(
            "v-list",
            { attrs: { "two-line": "", subheader: "" } },
            [
              _vm.authorizedTenants.length > 0
                ? _c(
                    "v-subheader",
                    [
                      _c("v-icon", { attrs: { color: "info" } }, [
                        _vm._v("mdi-information"),
                      ]),
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.userInfo.displayName) +
                          ": Choose the tenant you would like to access.\n      "
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.authorizedTenants.length == 0
                ? _c(
                    "v-subheader",
                    [
                      _c("v-icon", { attrs: { color: "warning" } }, [
                        _vm._v("mdi-information"),
                      ]),
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.userInfo.displayName) +
                          ", your Hatfield account is not authorized to access any Envirodata tenants. Please contact the administrator.\n      "
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm._l(_vm.authorizedTenants, function (item) {
                return _c(
                  "v-list-tile",
                  {
                    key: item.UserId,
                    nativeOn: {
                      click: function ($event) {
                        return _vm.impersonate(item)
                      },
                    },
                  },
                  [
                    _c(
                      "v-tooltip",
                      {
                        attrs: { bottom: "" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "activator",
                              fn: function ({ on }) {
                                return [
                                  _c(
                                    "v-list-tile-content",
                                    _vm._g(
                                      { staticStyle: { cursor: "pointer" } },
                                      on
                                    ),
                                    [
                                      _c("v-list-tile-title", [
                                        _vm._v(_vm._s(item.TenantName)),
                                      ]),
                                      _vm._v(" "),
                                      _c("v-list-tile-sub-title", [
                                        _vm._v(_vm._s(item.UserName)),
                                      ]),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          true
                        ),
                      },
                      [
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(
                            "Click to access tenant " + _vm._s(item.TenantName)
                          ),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "v-list-tile-action",
                      [
                        _c(
                          "v-btn",
                          { attrs: { icon: "", ripple: "" } },
                          [
                            _c(
                              "v-icon",
                              { attrs: { large: "", color: "grey lighten-1" } },
                              [_vm._v("mdi-chevron-right")]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              }),
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", "max-width": "360" },
          model: {
            value: _vm.impersonating,
            callback: function ($$v) {
              _vm.impersonating = $$v
            },
            expression: "impersonating",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-text",
                { staticClass: "text-xs-center pt-4 pb-4" },
                [
                  _c("v-progress-circular", {
                    attrs: { indeterminate: "", color: "primary", size: "48" },
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "mt-3 title" }, [
                    _vm._v(_vm._s(_vm.impersonatingTenant)),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "mt-1 subheading" }, [
                    _vm._v(
                      "The system is impersonating this login. Please wait for completion."
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }